var _rect, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgOnline = function SvgOnline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#10B364"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.56,
    fill: "#fff",
    d: "M18.036 15.286h3.929v13.357h-3.929z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M11.75 15.678s4.125-.392 8.25-.392 8.25.393 8.25.393l.196 1.964.197 2.357H11.357l.197-2.357.196-1.965ZM12.536 20h14.928s.393 2.16.393 4.321c0 2.161-.785 4.322-.785 4.322H12.928s-.786-2.16-.786-4.322c0-2.16.393-4.321.393-4.321Z",
    stroke: "#fff",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M20 15.286s.124-2.762.438-3.705c.542-1.625 2.038-1.505 2.696-.959.658.546 1.199 1.91 0 3.051-.66.627-3.134 1.613-3.134 1.613ZM19.916 15.286s-.124-2.762-.438-3.705c-.542-1.625-2.038-1.505-2.696-.959-.658.546-1.2 1.91 0 3.051.66.627 3.134 1.613 3.134 1.613Z",
    stroke: "#fff",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20 15.286c3.201-.588 5.465-1.574 6.791-2.958M19.925 15.286s-5.793-.882-7.782-2.958",
    stroke: "#fff",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgOnline;